export const localStorageKeys = {
  accessingPolicy: 'ew:accessing-policy',
};
